module.exports = "file://" + context.plugin.urlForResourceNamed("_webpack_resources/bf3eeb72ebc3c9bb51e81969208fcf8a.html").path();